import React, {
  useState,
  useMemo,
  Fragment,
  memo,
  useEffect,
  useRef,
} from "react";
import _, { isArray } from "lodash";
import { useTable } from "react-table";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { format, differenceInDays, setHours } from "date-fns";
import Swal from "sweetalert2";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Select from "react-select";
import { EmitterStatus } from "../../event";
import { checkRole } from "../../utils/role";
import moment from "moment";
import { saveAs } from "file-saver";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import font from "../../styles/CORDIA.ttf";
import fontBold from "../../styles/Cordia New Bold.ttf";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  DataTableCell,
} from "@david.kucsai/react-pdf-table";

// COMPONENTS
import LoadingPage from "../Loading/LoadingPage";
import ContainerContent from "../Container/ContainerContent";

// HOOKS
import useGetLoanId from "../../hooks/useGetLoanId";

// UTILS
import {
  getCurrentLocalDateTime,
  pad,
  months,
} from "../../utils/getLocalDateTime";
import { QRCodeCanvas } from "qrcode.react";
import { QRCode } from "react-qrcode-logo";

// OTHER
import numeral from "numeral";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { calculatorDisabledPeriodRemain } from "utils/calculator";
import { getCheckCurrentDate, getTotalAmount } from "utils/calculator";
import { getRefId, getValueAmount } from "../../utils/qrcode";

const optionsPeriod = [
  {
    label: "3",
    value: "3",
  },
  {
    label: "6",
    value: "6",
  },
  {
    label: "8",
    value: "8",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "18",
    value: "18",
  },
  // {
  //   label: "24",
  //   value: "24",
  // },
  // {
  //   label: "36",
  //   value: "36",
  // },
  // {
  //   label: "48",
  //   value: "48",
  // },
  // {
  //   label: "60",
  //   value: "60",
  // },
];

const optionsPackage = [
  {
    label: "อุปโภค / บริโภค",
    value: "อุปโภค / บริโภค",
  },
  {
    label: "ท่องเที่ยว",
    value: "ท่องเที่ยว",
  },
  {
    label: "ธุรกิจ",
    value: "ธุรกิจ",
  },
];

const colorStatus = (status) => {
  if (status == "ACTIVE") return "text-green-500";
  if (status == "REFINANCE") return "text-purple-500";
  if (status == "DONE") return "text-green-600";
  if (status == "PENDING") return "text-yellow-500";

  return "text-red-500";
};

const today = getCurrentLocalDateTime();
function LoanId() {
  const { user } = useSelector((state) => state.initializeApp);

  const [selectMonth, setSelectMonth] = useState(pad(today.month));
  const [selectDate, setSelectDate] = useState(pad(today.date));
  const [selectYear, setSelectYear] = useState(today.year);
  const [selectHour, setSelectHour] = useState(pad(today.hours));
  const [selectMinute, setSelectMinute] = useState(pad(today.minutes));
  const [checkTime, setCheckTime] = useState(false);

  const [attachments, setAttachments] = useState([]);
  const [attachmentViews, setAttachmentViews] = useState([]);
  const [oriAttachments, setOriAttachments] = useState([]);
  const [loadingSaveAttchment, setLoadingSaveAttachment] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [checkCreate, setCheckCreate] = useState(false);
  const [loadingCaseNumber, setLoadingCaseNumber] = useState(false);
  const [loadingQrPayment, setLoadingQrPayment] = useState(false);

  const fileRef = useRef();

  const years = new Array(3).fill(today.year).map((year, index) => {
    const value = year - index;
    return {
      label: value,
      value,
    };
  });

  const optionsYears = years;

  const optionsMonths = months
    // .slice(0, today.month)
    .map((_, index) => {
      return {
        label: `${pad(index + 1)}`,
        value: `${pad(index + 1)}`,
        index,
      };
    })
    .reverse();

  const dayOfMonth = months[Number(selectMonth - 1)].days;

  const optionsDates = new Array(dayOfMonth)
    .fill(dayOfMonth)
    // .slice(0, +selectDate)
    .map((_, index) => {
      const value = index + 1;
      return {
        label: `${pad(value)}`,
        value: `${pad(value)}`,
        index,
      };
    })
    .reverse();

  const optionsHours = useMemo(() => {
    return [{ label: "00", value: "00" }]
      .concat(
        new Array(23)
          .fill(23)
          // .slice(0, selectDate < +today.date ? 23 : +today.hours)
          .map((_, index) => {
            const value = index + 1;
            return {
              label: `${pad(value)}`,
              value: `${pad(value)}`,
              index,
            };
          })
      )
      .reverse();
  }, [selectHour]);

  const optionsMintues = useMemo(() => {
    let sliceMintues = +selectHour < +today.hours ? 59 : +today.minutes;

    return [{ label: "00", value: "00" }]
      .concat(
        new Array(59)
          .fill(59)
          // .slice(0, sliceMintues)
          .map((_, index) => {
            const value = index + 1;
            return {
              label: `${pad(value)}`,
              value: `${pad(value)}`,
              index,
            };
          })
      )
      .reverse();
  }, [selectHour, selectMinute]);

  const router = useHistory();
  const params = useParams();
  const {
    data,
    loading,
    setLoading,
    error: errorQuery,
    getData,
  } = useGetLoanId({
    loan_id: params.loan_id,
    paid_date: today.dateTime,
  });

  const handleApprove = useFullScreenHandle();

  const default_query = {
    paid_date: today.dateTime,
  };

  const default_form = {
    paid_date: today.dateTimeLocal,
    paid_amount: 0,
    bill_img: "",
    formatPay: "normal",
    newPeriod: "12",
    newInterest: data?.type,
  };

  const [isExpand, setExpand] = useState(false);
  const [showEvidence, setShowEvidence] = useState("");

  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [billBase, setBillBase] = useState("");
  const [form, setForm] = useState(default_form);
  const [query, setQuery] = useState(default_query);
  const [preview, setPreview] = useState([]);
  const [evidence, setEvidence] = useState();
  const [caseNumber, setCaseNumber] = useState("");

  const [isEditEmail, setIsEditEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [passwordEmail, setPasswordEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState("");

  useEffect(() => {
    if (data) {
      setCaseNumber(data.caseNumber);
      setEmail(data.email);
      // setPhoneNumber(data.phone_number);
    }
  }, [data]);

  const onChangeCaseNumber = (e) => {
    const value = e.target.value;
    setCaseNumber(value);
  };

  const getDataEvidence = () => {
    if (!data?.evidence?.length) return null;
    const filterPending = data.evidence.filter(
      (ev) => ev.evidence_status === "PENDING"
    );
    const lastIndex = filterPending.length - 1;
    return filterPending[lastIndex];
  };

  const queryAttachment = async () => {
    try {
      const dataAttachment = await API.get(
        "MoneyHubAdmin",
        `/loan/attachment/${data.phone_number}`,
        {
          queryStringParameters: {},
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      if (dataAttachment.status === "Y") {
        setCheckCreate(true);
      }

      if (dataAttachment.Item?.attachments.length > 0) {
        const signedAttachments = [];
        for (const attachment of dataAttachment.Item.attachments) {
          const signedURL = await Storage.get(attachment);
          signedAttachments.push({ name: attachment, link: signedURL });
        }
        setOriAttachments(signedAttachments);
      }
    } catch (error) {
      console.log("Query Attachment", error);
    }
  };

  const uploadAttachment = async () => {
    try {
      let newAttachments = [];
      if (attachments.length > 0) {
        const today = getCurrentLocalDateTime();
        for (const attachment of attachments) {
          const fileName = `${today.fullDate}_${today.hours}:${today.minutes}_${attachment?.name}`;
          const keyImg = await Storage.put(fileName, attachment);
          newAttachments.push(keyImg.key);
        }
      }

      if (oriAttachments.length > 0) {
        newAttachments = [
          ...oriAttachments.map((attachment) => attachment.name),
          ...newAttachments,
        ];
      }
      return newAttachments;
    } catch (error) {
      console.log("Upload Error Attachment", error);
    }
  };

  const onSaveAttachment = async () => {
    try {
      setLoadingSaveAttachment(true);
      const attachments = await uploadAttachment();
      if (checkCreate) {
        await API.put(
          "MoneyHubAdmin",
          `/loan/attachments/${data.phone_number}`,
          {
            body: {
              attachments,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          }
        );
      } else {
        await API.post("MoneyHubAdmin", `/loan/attachments`, {
          body: {
            loan_id: data.loan_id,
            request_id: data.request_id,
            loan_kbank_id: data.loan_kbank_id,
            phone_number: data.phone_number,
            attachments,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
      }
    } catch (error) {
      console.log("onSaveAttachment", error);
    } finally {
      await queryAttachment();
      setLoadingSaveAttachment(false);
      setAttachments([]);
      setAttachmentViews([]);
      setCheckEdit(false);
      fileRef.current.value = "";
    }
  };

  const onDeleteAttachment = (index) => {
    const filterAttachments = oriAttachments.filter(
      (_, myIndex) => myIndex !== index
    );
    setOriAttachments(filterAttachments);
    setCheckEdit(true);
  };

  useEffect(() => {
    if (!data) return;
    const dataEvidence = getDataEvidence();
    setExpand(!!dataEvidence);
    setForm((prev) => {
      return {
        ...prev,
        paid_date: dataEvidence?.paid_date || today.dateTimeLocal,
        paid_amount: dataEvidence ? +dataEvidence.paid_amount : 0,
      };
    });
    setEvidence(
      data?.evidence?.sort((a, b) => {
        return a?.paid_date < b?.paid_date ? 1 : -1;
      })
    );
    if (dataEvidence?.paid_date) {
      const paid_date = getCurrentLocalDateTime(
        new Date(dataEvidence?.paid_date)
      );
      setSelectDate(pad(paid_date.date));
      setSelectMonth(pad(paid_date.month));
      setSelectYear(pad(paid_date.year));
      setSelectHour(pad(paid_date.hours));
      setSelectMinute(pad(paid_date.minutes));
    }
    queryAttachment();
  }, [data, loading]);

  if (loading) {
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  }
  if (errorQuery) {
    <ContainerContent>Error...</ContainerContent>;
  }

  const dataEvidence = getDataEvidence();

  // const evidence = useMemo(() => {
  //   return data?.evidence?.sort((a, b) => {
  //     return a?.paid_date < b?.paid_date ? 1 : -1;
  //   });
  // }, []);

  const urltoFile = async (url, filename, mimeType) => {
    const res = await fetch(url);
    const buf = await res.arrayBuffer();
    return new File([buf], filename, { type: mimeType });
  };

  const onClickSendQRSMS = async () => {
    try {
      if (data?.loan_status === "DONE") {
        return;
      }

      setLoadingQrPayment(true);
      const canvas = document.getElementById("qr_code");
      const pngUrl = canvas.toDataURL("image/png");
      // .replace("image/png", "image/octet-stream");

      const qrCodeS3Key = `QRPayment${getRefId(
        data.loan_kbank_id,
        data.evidence.length
      )}.png`;
      const url = await urltoFile(pngUrl, qrCodeS3Key, "image/png");
      const config = {
        bucket: "mhsqrpayment", //REQUIRED -  Amazon S3 bucket name
        region: "ap-southeast-1", //OPTIONAL -  Amazon service region
      };
      await Storage.put(qrCodeS3Key, url, config);
      const qrCodeGetUrl = `https://d2qcqcfczpjn23.cloudfront.net/public/qrcode.html?qrcode=${qrCodeS3Key}`;
      await API.post("MoneyHubAdmin", `/broadcast/notify`, {
        body: {
          phone_number: `${phone_number.slice(1, String(phone_number).length)}`,
          description: `ลิงค์ QR code สำหรับชำระเงินเลขที่สัญญา ${String(
            data?.loan_kbank_id
          )}, ${qrCodeGetUrl}`,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setPhoneNumber("");
      await EmitterStatus("SUCCESS", { text: "ส่งข้อมูลสำเร็จ" });
    } catch (error) {
      console.log("onClickSendQRSMS", error);
      await EmitterStatus("SUCCESS", { text: "ส่งข้อมูลไม่สำเร็จ" });
    } finally {
      setLoadingQrPayment(false);
    }
  };

  const onChangeDate = (e) => {
    setQuery((prev) => {
      return {
        ...prev,
        paid_date: e.target.value,
      };
    });
  };

  const onChangeAttachment = (e) => {
    const files = e.target.files;
    const filesArr = Array.prototype.slice.call(e.target.files);
    setAttachmentViews(filesArr);
    setAttachments(files);
    setCheckEdit(true);
  };

  const onClickUpdateCaseNumber = async () => {
    try {
      setLoadingCaseNumber(true);
      await API.put("MoneyHubAdmin", `/loan/caseNumber/${data.loan_id}`, {
        body: {
          caseNumber,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await getData(query, { isLoading: false });
    } catch (error) {
      console.log("update case number", error);
    } finally {
      setLoadingCaseNumber(false);
    }
  };

  const onRefetch = async () => {
    await getData({ params: query });
  };

  const onSubmitCancel = () => async (e) => {
    try {
      const paid_date = `${selectYear}-${pad(selectMonth)}-${pad(
        selectDate
      )}T${pad(selectHour)}:${pad(selectMinute)}:${pad(today.seconds)}`;
      await API.put("MoneyHubAdmin", `/loan/confirmPayment`, {
        body: {
          loan_id: data.loan_id,
          paid_amount: +form.paid_amount,
          paid_date: paid_date,
          confirmPaymentStatus: "DONE",
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await EmitterStatus("SUCCESS");
      await getData(query);
    } catch (error) {
      await EmitterStatus("WARNING", {
        text: "Something went wrong",
      });
    }
  };

  const onSubmitEvidence = (evidence_status) => async (e) => {
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async () => {
        try {
          const paid_date = `${selectYear}-${pad(selectMonth)}-${pad(
            selectDate
          )}T${pad(selectHour)}:${pad(selectMinute)}:${pad(today.seconds)}`;
          if (
            new Date(paid_date + "+07:00").getTime() >
            new Date(moment().format()).getTime()
          ) {
            await EmitterStatus("WARNING", {
              text: "คุณไม่สามารถเลือกวันเวลาในอนาคตได้",
            });
            return;
          }

          let errorMessage = "";
          let error = false;
          if (!dataEvidence && !billBase) {
            setError(true);
            errorMessage += "โปรดเลือกไฟล์";
            error = true;
          }
          if (+form.paid_amount === 0) {
            errorMessage = errorMessage
              ? ` และ โปรดกรอกจำนวนเงิน`
              : "โปรดกรอกจำนวนเงิน";
            error = true;
          }

          let amountDebt =
            data.capitalRemain +
            data.installments.reduce((prev, installment) => {
              return installment.actualInterest + prev;
            }, 0);

          if (amountDebt <= 0) {
            error = true;
            errorMessage = "ไม่สามารถจ่ายตังได้ เนื่องจากยอดเกินกำหนดที่ชำระ";
          }
          // if (
          //   data.installments.every((installment) => installment.disabledPeriod)
          // ) {
          //   error = true;
          //   errorMessage = "ไม่สามารถจ่ายตังได้ เนื่องจากงวดปิดหมดแล้ว";
          // }

          if (error && evidence_status === "APPROVE") {
            setError(true);
            return { error, errorMessage };
          }

          let canPaid = true;

          if (
            typeof data.confirmPayment === "undefined" ||
            data.confirmPayment === null
          ) {
            // console.log("data", Boolean(data.confirmPayment));
            // console.log("dataEvidence", dataEvidence);
            await API.put("MoneyHubAdmin", `/loan/confirmPayment`, {
              body: {
                loan_id: data.loan_id,
                paid_amount: +form.paid_amount,
                paid_date: paid_date,
                confirmPaymentStatus: "PAID",
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
            setForm((prev) => {
              return {
                ...default_form,
                formatPay: prev.formatPay,
              };
            });
            setBillBase("");
            console.log("1");
            return { isConfirmed: true };
          } else {
            console.log("2");
            const confirmPaymentDateFormat = getCurrentLocalDateTime(
              data.confirmPayment.paid_date
            );
            let confirmPaymentDate = `${confirmPaymentDateFormat.year}-${pad(
              confirmPaymentDateFormat.month
            )}-${pad(confirmPaymentDateFormat.date)}T${pad(
              confirmPaymentDateFormat.hours
            )}:${pad(confirmPaymentDateFormat.minutes)}`;
            let paymentDate = `${selectYear}-${pad(selectMonth)}-${pad(
              selectDate
            )}T${pad(selectHour)}:${pad(selectMinute)}`;

            if (
              data.confirmPayment.paid_amount === +form.paid_amount &&
              confirmPaymentDate === paymentDate
            ) {
              canPaid = true;
            } else {
              setForm((prev) => {
                return {
                  ...default_form,
                  formatPay: prev.formatPay,
                };
              });
              setBillBase("");
              return {
                error: true,
                errorMessage: "โปรดจ่ายยอดให้ตรงที่กำหนด",
              };
            }
          }

          if (evidence_status === "REJECT") {
            canPaid = true;
          }

          if (canPaid) {
            let newBill_img = "";
            if (form.bill_img) {
              const fileName = `${new Date().getTime()}_${
                form?.bill_img?.name
              }`;
              newBill_img = await Storage.put(fileName, form.bill_img);
            }

            await API.put("MoneyHubAdmin", `/loan/evidence/${data.loan_id}`, {
              body: {
                paid_amount: +form.paid_amount,
                // paid_date: form.paid_date,
                paid_date: `${selectYear}-${pad(selectMonth)}-${pad(
                  selectDate
                )}T${pad(selectHour)}:${pad(selectMinute)}:${pad(
                  today.seconds
                )}`,
                adminName: user.username,
                _id: dataEvidence ? dataEvidence._id : "",
                isNew: !dataEvidence,
                bill_img: newBill_img ? newBill_img.key : dataEvidence.bill_img,
                evidence_status,
                test: true,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });

            await API.put("MoneyHubAdmin", `/loan/confirmPayment`, {
              body: {
                loan_id: data.loan_id,
                paid_amount: +form.paid_amount,
                paid_date: paid_date,
                confirmPaymentStatus: "DONE",
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
            setForm((prev) => {
              return {
                ...default_form,
                formatPay: prev.formatPay,
              };
            });
            setBillBase("");
          }
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    if (result.value.error) {
      return await EmitterStatus("WARNING", {
        text: result.value.errorMessage,
      });
    }
    await EmitterStatus("SUCCESS");
    // window.location.reload();
    setLoading(true);
    await getData(query);
    setLoading(false);
  };

  const onSelect = (name) => (e) => {
    const { value } = e;
    setForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onChangeFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    getBase64(file);
    setForm((prev) => {
      return {
        ...prev,
        bill_img: file,
      };
    });
  };

  const onChangeForm = (e) => {
    setForm((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const onWave = async () => {
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async () => {
        try {
          let waveRemain = +data.waveRemain;
          if (waveRemain === 0) {
            return {
              error: true,
              errorMessage: "Wave ครบตามจำนวนที่กำหนดไว้แล้ว",
            };
          }
          await API.put("MoneyHubAdmin", `/loan/wave/${data.loan_id}`, {
            body: {
              paid_amount: form.paid_amount,
              paid_date: form.paid_date,
              adminName: user.username,
              reason: form.reason,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
          setForm((prev) => {
            return {
              ...default_form,
              formatPay: prev.formatPay,
            };
          });
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    if (result.value.error) {
      return await EmitterStatus("WARNING");
    }
    await EmitterStatus("SUCCESS");
    await getData(query, { isLoading: false });
  };

  const getBase64 = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBillBase(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const onFail = async () => {
    const { loan_id } = data;
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะยกเลิกสัญญานี้หรือไม่ ? ?",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async (reason) => {
        try {
          await API.put("MoneyHubAdmin", `/loan/status/${loan_id}`, {
            body: {
              loan_status: "FAIL",
              reason,
              adminName: user.username,
              faild_by: user.username,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    if (result.value.error) {
      return EmitterStatus("WARNING");
    }
    await EmitterStatus("SUCCESS");
    await getData(query, { isLoading: false });
  };

  const onRefinance = async () => {
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async () => {
        try {
          const {
            phone_number,
            request_id,
            requestamount,
            payPerMonth,
            loan_id,
            installments,
            interestMore,
            loan_kbank_id,
            capitalRemain,
          } = data;

          const installmentOpenLatest = installments.find(
            (installment) => !installment.disabledPeriod
          );
          const installmentOpenLatestIndex = installments.findIndex(
            (installment) => !installment.disabledPeriod
          );

          let newRequestAmount =
            capitalRemain + interestMore + installmentOpenLatest.actualInterest;

          const refinance_amount = newRequestAmount;

          const refinance_date = getCurrentLocalDateTime().isoDateTime;

          await API.post("MoneyHubAdmin", `/loanRequest/refinance`, {
            body: {
              loan_id,
              request_id,
              loan_kbank_id,
              requestamount: newRequestAmount,
              refinance_date,
              period: +form.newPeriod,
              purpose: data?.type,
              refinance_ar_loan: capitalRemain,
              refinance_interest:
                interestMore + installmentOpenLatest.actualInterest,
              refinance_accumulated_interest: interestMore,
              refinance_period: `${installmentOpenLatestIndex}/${installments.length}`,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });

          await API.put("MoneyHubAdmin", `/loan/status/${loan_id}`, {
            body: {
              loan_status: "ACTIVE",
              refinance_amount,
              refinance_date,
              refinance_ar_loan: capitalRemain,
              refinance_interest:
                interestMore + installmentOpenLatest.actualInterest,
              refinance_accumulated_interest: interestMore,
              refinance_period: `${installmentOpenLatestIndex}/${installments.length}`,
              reason: "",
              adminName: user.username,
              faild_by: "",
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    await EmitterStatus("SUCCESS");
    setShowModal(false);
    await getData(query, { isLoading: false });
  };

  const previewRefinance = async () => {
    const { interestMore, installments, capitalRemain } = data;

    const installmentOpenLatest = installments.find(
      (installment) => !installment.disabledPeriod
    );

    let newRequestAmount =
      capitalRemain + interestMore + installmentOpenLatest.actualInterest;
    const dataPreview = await API.get("MoneyHubAdmin", "/loan/preview", {
      queryStringParameters: {
        period: +form.newPeriod,
        requestamount: newRequestAmount,
        purpose: data.type,
        promo: 0,
      },
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });
    setPreview(JSON.parse(dataPreview.body).Item);
    setShowModal(true);
  };

  const showEvidencePopup = (index) => {
    setShowEvidence(index);
  };

  const getOption = (options, value) => {
    const findIndex = options.findIndex((option) => option.value === value);
    return options[findIndex];
  };

  const onSelectMonth = (e) => {
    const currentMonth = e;
    const diff_days = months[currentMonth.index].days - selectDate;
    if (diff_days < 0) {
      setSelectDate(`${pad(months[currentMonth.index].days)}`);
    }
    setSelectMonth(e.value);
  };

  const onSelectDate = (e) => {
    setSelectDate(e.value);
  };

  const onSelectYear = (e) => {
    setSelectYear(e.value);
  };

  const onSelectHour = (e) => {
    if (+e.value < +today.hours) {
      setSelectMinute(59);
    } else {
      const newToday = getCurrentLocalDateTime();
      setSelectMinute(pad(newToday.minutes));
    }
    setSelectHour(e.value);
  };

  const onSelectMintue = (e) => {
    setSelectMinute(e.value);
  };

  const getBillValue = (kbankid, amount, count = 0) => {
    const MONEY_HUB_TAX_ID = "010556313826600";
    if (count < 10) count = "0" + count;
    else count = "" + count;
    const ref_number = kbankid + count;
    return "|" + MONEY_HUB_TAX_ID + "\n" + ref_number + "\n\n" + amount + "00";
  };

  Font.register({
    family: "Cordia New",
    fonts: [{ src: font }, { src: fontBold }],
  });

  var isProcessing = false;

  const styles = StyleSheet.create({
    page: {
      fontFamily: "Cordia New",
      padding: 10,
      fontSize: 14,
      backgroundColor: "#fff",
    },
    flex: {
      display: "flex",
    },
    viewHeader: {
      marginTop: "16px",
      paddingLeft: "52px",
      paddingRight: "52px",
    },
    textHeader: {
      textAlign: "center",
      fontSize: 20,
      marginBottom: "16px",
    },
    bold: {
      fontSize: 16,
      fontWeight: "bold",
    },
    spaceX: {
      marginLeft: "18px",
      marginRight: "18px",
    },
    text: {
      fontSize: 16,
    },
    section: {
      marginTop: "36px",
      marginLeft: "42px",
    },
    space: {
      margin: "2px",
    },
    installment: {
      display: "flex",
      marginTop: "16px",
    },
  });

  const PdfDocument = () => {
    return (
      <Document>
        <Page style={styles.page}>
          <View style={styles.viewHeader}>
            <Text style={styles.textHeader}>รายละเอียดการผ่อนชำระ</Text>
            <View style={styles.space}></View>
            <Text>
              <Text style={styles.bold}>ชื่อผู้ทำสัญญา</Text>
              <View style={styles.spaceX}> </View>
              <Text style={styles.text}>{data.fullname}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
              <Text style={styles.spaceX}> </Text>
              <Text style={styles.bold}>รหัสบัตรประชาชน</Text>
              <Text style={styles.spaceX}> </Text>
              <Text style={styles.text}>{data.citizenid}</Text>
            </Text>
            <Text>
              <Text style={styles.bold}>เลขที่สัญญา</Text>
              <View style={styles.spaceX}> </View>
              <Text style={styles.text}>{data.loan_kbank_id}</Text>
            </Text>
            <Text>
              <Text style={styles.bold}>วงเงินสินเชื่อ</Text>
              <View style={styles.spaceX}> </View>
              <Text style={styles.text}>
                {numeral(data.requestamount).format("0,000")}
              </Text>
              <Text style={styles.spaceX}> </Text>
              <Text style={styles.bold}>อัตราดอกเบี้ย</Text>
              <Text style={styles.spaceX}> </Text>
              <Text style={styles.text}>{data.interest_rate}%</Text>
            </Text>
            <Text>
              <Text style={styles.bold}>ระยะเวลาผ่อนชำระ</Text>
              <View style={styles.spaceX}> </View>
              <Text style={styles.text}>{data.period} งวด</Text>
            </Text>
            <Text>
              <Text style={styles.bold}>วันที่เริ่มต้นสัญญา</Text>
              <View style={styles.spaceX}> </View>
              <Text style={styles.text}>
                {format(new Date(data.beginDate), "dd/MM/yyyy")}
              </Text>
              <Text style={styles.spaceX}> </Text>
              <Text style={styles.bold}>วันที่สิ้นสุดสัญญา</Text>
              <View style={styles.spaceX}> </View>
              <Text style={styles.text}>
                {format(new Date(data.endDate), "dd/MM/yyyy")}
              </Text>
            </Text>
          </View>
          <View style={styles.installment}>
            <Table
              data={data.installments.map((installment, index) => {
                return { ...installment, period: index + 1 };
              })}
            >
              <TableHeader textAlign={"center"}>
                <TableCell>งวดที่</TableCell>
                <TableCell>เงินต้น</TableCell>
                <TableCell>ดอกเบี้ย</TableCell>
                <TableCell>ดอกเบี้ยสะสม</TableCell>
                <TableCell>รวมค่างวด</TableCell>
                <TableCell>เงินต้นคงเหลือ</TableCell>
                {/* <TableCell>วันที่ชำระ</TableCell>
                <TableCell>สถานะ</TableCell> */}
              </TableHeader>
              <TableBody textAlign={"center"}>
                <DataTableCell getContent={(r) => r.period} />
                <DataTableCell
                  getContent={(r) => numeral(r.actualPrinciple).format("0,000")}
                />
                <DataTableCell getContent={(r) => r.actualInterest} />
                <DataTableCell getContent={(r) => r.interestMore} />
                <DataTableCell
                  getContent={(r) =>
                    numeral(
                      r.actualPrinciple + r.actualInterest + r.interestMore
                    ).format("0,000")
                  }
                />
                <DataTableCell
                  getContent={(r) =>
                    numeral(r.planCapitalRemain).format("0,000")
                  }
                />
                {/* <DataTableCell
                  getContent={(r) =>
                    r.paid_date !== "-"
                      ? format(new Date(r.paid_date), "dd-MM-yyyy")
                      : "-"
                  }
                />
                <DataTableCell
                  getContent={(r) => (r.disabledPeriod ? "ปิด" : "เปิด")}
                /> */}
              </TableBody>
            </Table>
          </View>
        </Page>
      </Document>
    );
  };

  const getDifferentFromNow = (value) => {
    const date1 = new Date();
    const date2 = new Date(value);
    const diffTime = Math.abs(date2 - date1);
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  };

  const getCurrent = () => {
    if (!data) return 0;
    let currentDateIndex = getCheckCurrentDate(data.installments);
    let prevIndex = currentDateIndex - 1;
    if (prevIndex < 0) {
      prevIndex = 0;
    }
    if (getDifferentFromNow(data.installments[prevIndex].date) > 15) {
      return currentDateIndex;
    } else {
      return currentDateIndex - 1;
    }
  };

  const showAmountWithOutCurrent = () => {
    var sum = 0;

    var items = _.cloneDeep(data.installments);
    var init = getCurrent();
    if (init < 0) init = 0;

    for (let i = init; i >= 0; i--) {
      let prev = items[i].actualPrinciple;
      if (prev > 0)
        sum +=
          Number(items[i].actualPrinciple) + Number(items[i].actualInterest);
      else break;
    }

    return sum.toString();
  };

  const getGlobalTotalAmount = () => {
    let last_total = 0;
    if (data) {
      for (let index = 0; index < data.installments.length; index++) {
        const installment = data.installments[index];
        const currentDateIndex = getCheckCurrentDate(data?.installments);
        const checkCurrentDateIndex = currentDateIndex === index;
        if (checkCurrentDateIndex) {
          last_total = getTotalAmount(
            checkCurrentDateIndex,
            data,
            installment,
            index
          );
        }
      }
    }
    return last_total;
  };

  const generatePdfDocument = async () => {
    if (isProcessing) toast.warn("กำลังทำรายการโปรดรอสักครู่");
    else isProcessing = true;

    let filename = `EXPORT_INSTALLMENT_${new Date().toISOString()}.pdf`;

    /// Cal increment Lamba to get Count here
    try {
      let blob = await pdf(<PdfDocument title={filename} />).toBlob();
      saveAs(blob, filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      alert(error);
      isProcessing = false;
    }
  };

  const statusVerison = (installment) => {
    if (data.version === "2") {
      if (
        ["ปิด-เลท", "ค้างชำระ", "ปิด-ตรงเวลา", "ปิด-โปะ"].includes(
          installment?.displayStatus
        )
      ) {
        if (installment?.displayStatus === "ปิด-ตรงเวลา") {
          return (
            <div className=" text-base text-red-500 font-bold mt-2">
              <div className="flex flex-col">
                <div>ปิด</div>
                <div>ตรงเวลา</div>
              </div>
            </div>
          );
        } else {
          return (
            <div className=" text-base text-red-500 font-bold mt-2">
              {installment?.displayStatus}
            </div>
          );
        }
      } else {
        return (
          <div className=" text-base text-green-500 font-bold mt-2">เปิด</div>
        );
      }
    } else {
      if (!installment?.disabledPeriod) {
        return (
          <div className=" text-base text-green-500 font-bold mt-2">เปิด</div>
        );
      } else {
        return (
          <div className=" text-base text-red-500 font-bold mt-2">ปิด</div>
        );
      }
    }
  };

  const onClickEditEmail = async () => {
    try {
      setLoadingEmail(true);
      await API.put("MoneyHubAdmin", `/loan/email/${data.loan_id}`, {
        body: {
          email: email,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setIsEditEmail(false);
      setPasswordEmail("");
    } catch (error) {
      console.log("edit email error", error);
    } finally {
      setLoadingEmail(false);
    }
  };

  let check_ems = true;

  if (data.ems_first && data.ems_second) {
    check_ems = false;
  }

  if (showModal)
    return (
      <div className="bg-gray-100 fixed z-20 inset-0 w-full h-screen mx-auto">
        <div className="w-full h-14 p-2 bg-white flex flex-row justify-end mb-4">
          <div className="w-full text-left mx-4 flex flex-row">
            <div className="h-full text-base mt-2 mx-4">
              {data.loan_kbank_id}
            </div>
            <div className="h-full text-base mt-2 mx-4">
              {data.name} {data.lastname}
            </div>
            <div className="h-full text-base mt-2 mx-4">
              วงเงิน {numeral(data.capitalRemain).format("0,00")}
            </div>
            <div className="h-full text-base mt-2 mx-4">
              ดอกเบี้ย สะสม {numeral(data.interestMore).format("0,00")} /
              ปัจจุบัน{" "}
              {numeral(
                data.installments.find(
                  (installment) => !installment.disabledPeriod
                ).actualInterest
              ).format("0,00")}
            </div>

            <div className="h-full text-base mt-2 mx-4"> {data.type}</div>
            <div className="h-full text-base mt-2 mx-4">
              {" "}
              {format(
                new Date(data.requestTime).getTime() + 432000000,
                "dd-MM-yyyy"
              )}
            </div>
          </div>
          <div className=" w-44">
            <Select
              // disabled
              options={optionsPeriod}
              value={getOption(optionsPeriod, form.newPeriod)}
              onChange={onSelect("newPeriod")}
            />
          </div>
          {/*}
          <div className=" w-52 mr-4">
            <Select
              isDisabled
              options={optionsPackage}
              value={getOption(optionsPackage, data.type)}
              onChange={onSelect("newInterest")}
            />
    </div>*/}
          <button
            onClick={previewRefinance}
            className="mx-0 px-2 py-2 text-base rounded text-white bg-blue-500 mx-3"
          >
            Preview
          </button>
          <button
            onClick={() => setShowModal(false)}
            className="mx-0 px-4 py-2 text-base rounded text-white bg-red-500"
          >
            ยกเลิก
          </button>
          <button
            onClick={onRefinance}
            className="mx-3 px-4 py-2 text-base rounded text-white bg-green-500"
          >
            ยืนยัน
          </button>
        </div>
        <div className="flex flex-row justify-center">
          <div className="overflow-y-scroll h-screen-80">
            {data?.installments?.map((installment, index) => {
              return (
                <div className="flex items-center justify-center w-full mx-auto">
                  <div
                    className={
                      "border " +
                      (index > 0 ? "border-t-0" : "") +
                      " border-gray-300 flex flex-row w-full justify-between items-center mx-4 my-0 py-4"
                    }
                  >
                    <div className="items-center px-2">
                      <div>งวดที่ </div>
                      <div className=" text-base font-bold mt-2">
                        {index + 1}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>เงินต้นคงเหลือ</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planCapitalRemain).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>เงินค่างวด</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.actualPrinciple).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>ดอกเบี้ย</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planInterest).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>สถานะงวด</div>
                      {statusVerison(data.version, installment)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex flex-col my-auto mx-16">
            <svg
              // className="p-4 w-20 h-20"
              xmlns="http://www.w3.org/2000/svg"
              className="p-4 h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          <div className="overflow-y-scroll h-screen-80">
            {preview.map((installment, index) => {
              return (
                <div className="flex items-center justify-center w-full mx-auto">
                  <div
                    className={
                      "border " +
                      (index > 0 ? "border-t-0" : "") +
                      " border-gray-300 flex flex-row w-full justify-between items-center mx-4 my-0 py-4"
                    }
                  >
                    <div className="items-center px-2">
                      <div>งวดที่ </div>
                      <div className=" text-base font-bold mt-2">
                        {index + 1}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>เงินต้นคงเหลือ</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planCapitalRemain).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>เงินค่างวด</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.actualPrinciple).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>ดอกเบี้ย</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planInterest).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div>สถานะงวด</div>
                      {statusVerison(installment)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );

  return (
    <div
      className="fixed z-20 inset-0 h-screen"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {showEvidence != "" && (
        <S3Image
          className="w-full h-full object-contain fixed z-30 bg-black bg-opacity-60"
          imgKey={showEvidence}
          onClick={() => showEvidencePopup("")}
        />
      )}
      <div className="flex flex-row">
        <div className=" overflow-auto h-screen inline-block align-bottom border-b w-4/5 border-gray-300 bg-gray-100 rounded-none text-left shadow-xl transform transition-all sm:my-0 sm:align-middle ">
          <div className=" pt-4 pb-4 sm:p-2 border-b border-gray-300 shadow-sm">
            <div className="flex items-center">
              {/*
              <div className="pr-4 py-2  sm:flex sm:flex-row-reverse">
                <React.Fragment>
                  <button
                    onClick={() => router.push("/loan")}
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  >
                    Back
                  </button>
                </React.Fragment>
              </div>*/}
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-blue-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                <h3
                  className="text-lg leading-6 font-medium text-gray-400"
                  id="modal-title"
                >
                  <span className="text-blue-500">{data.loan_kbank_id}</span>
                  {"  | "}{" "}
                  <span className="text-gray-700">
                    {data.name} {data.lastname}
                  </span>
                  {"  | "}{" "}
                  <span className="text-gray-700">{data.phone_number}</span>
                  {"  | "}{" "}
                  <span className={colorStatus(data.loan_status)}>
                    {data.loan_status}
                  </span>
                  {"  | "}{" "}
                  <span className={"text-green-400"}>
                    ส่วนลด {data.promo} %
                  </span>
                </h3>
              </div>
              {/* <input
                className="border p-2"
                value={query.paid_date}
                type="date"
                onChange={onChangeDate}
              />
              <button
                onClick={onRefetch}
                className="mx-3 px-4 py-2 text-base rounded text-white bg-purple-500"
              >
                Date
              </button> */}
              {data.loan_status !== "FAILD" &&
                (checkRole(user.groups, ["SuperAdmin", "RefinanceStaff"]) ||
                  user.username === "Kritsakorn.su@tfg.co.th") && (
                  <button
                    disabled={check_ems}
                    onClick={onFail}
                    className="px-4 py-2 w-32 text-base rounded text-white "
                    className={classNames(
                      "px-4 py-2 w-32 text-base rounded text-white",
                      {
                        "bg-red-500 cursor-pointer": !check_ems,
                        "bg-gray-400 cursor-not-allowed": check_ems,
                      }
                    )}
                  >
                    Fail
                  </button>
                )}
              {data.loan_status !== "REFINANCE" &&
                (checkRole(user.groups, ["SuperAdmin", "RefinanceStaff"]) ||
                  user.username === "Kritsakorn.su@tfg.co.th") && (
                  <button
                    disabled={data?.refinance_amount > 0}
                    onClick={previewRefinance}
                    className={classNames(
                      "mx-3 px-4 py-2 text-base rounded text-white ",
                      {
                        "bg-gray-400 cursor-not-allowed":
                          data?.refinance_amount > 0,
                        "bg-purple-500 cursor-pointer":
                          data?.refinance_amount === 0,
                      }
                    )}
                  >
                    Refinance
                  </button>
                )}

              {data?.refinance_amount > 0 &&
                data?.loan_status === "REFINANCE" && (
                  <div className="mx-3 px-4 py-2 text-base rounded text-white bg-purple-500">
                    กำลังรีไฟแนนท์
                  </div>
                )}
              {/*
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                <h3
                  className="text-lg leading-6 font-medium text-gray-900"
                  id="modal-title"
                >
                  <div>งวด</div>
                  <input
                    type="text"
                    name="newPeriod"
                    disabled
                    className="w-18 m-3 mt-0 p-1 border border-gray-300 rounded"
                    onChange={onChangeForm}
                    value={form.newPeriod}
                  />
                  <Select
                    name="newInterest"
                    onChange={onChangeSelect}
                    value={{
                      label: form.newInterest,
                      value: form.newInterest,
                    }}
                    options={optionsInterest}
                  />
                 
                </h3>
              </div>
                  )}*/}
            </div>
          </div>

          <div className="bg-gray-50 my-1 text-center">
            <div className="grid grid-cols-6 max-w-7xl  mx-auto py-4 font-bold text-sm">
              <div>ประเภท : {data.type}</div>
              <div>ยอดเงินกู้ : {numeral(data.initCapital).format("0,0")}</div>
              <div
                className={classNames("mx-4", {
                  "text-red-400": data.capitalRemain < 0,
                })}
              >
                เงินกู้คงเหลือ : {numeral(data.capitalRemain).format("0,0")}
              </div>
              <div className="mx-4">
                รวมดอกเบี้ยสะสม : {numeral(data.interestMore).format("0,0")}
              </div>
              <div>
                รวมยอดจ่ายเกินสะสม (โปะ) :{" "}
                {numeral(data.overflow).format("0,0")}
              </div>
              {data.loan_status !== "DONE" && (
                <div>
                  วันกำหนดชำระ : {data?.overdue_date}
                  {/* {format(new Date(data.overdue_date), "dd-MM-yyyy")} */}
                </div>
              )}
            </div>
            <div className="grid grid-cols-5 text-sm  max-w-7xl mx-auto py-4 font-bold text-gray-600 bg-gray-100">
              <div>เลขบัตรประชาชน : {data.citizenid}</div>
              <div>วันเกิด : {data.birthdateTh}</div>
              <div>เลขบัญชี : {data.bankNo}</div>
              <div className="col-span-2">
                ที่อยู่ปัจจบุัน : {data.officialAddressCode}{" "}
                {data.officialAddressDesc} {data.currentAddress}
              </div>
            </div>
            {data.loan_status == "FAIL" && (
              <div className="p-4 px-8 border bg-red-100 border-red-500 max-w-md  mx-auto relative">
                <div className="text-lg text-red-600 font-bold">
                  ล้มเหลวเนื่องจาก {data.reason}{" "}
                </div>
                <div className="text-red-500"> โดย {data.adminName} </div>
              </div>
            )}

            <div className="flex flex-row">
              <div className="border border-gray-200 mt-4 px-2 py-3 mx-auto flex flex-col">
                <div>
                  เลขที่สัญญา{" "}
                  {getRefId(data?.loan_kbank_id, data.evidence?.length)}
                </div>
                <div>จำนวนเงิน {Number(getValueAmount(data)).toFixed(0)}</div>
                {isEditEmail ? (
                  <div className="pr-2">
                    {passwordEmail === "1112" ? (
                      <div>
                        <input
                          className="ml-2 px-2 py-1 w-full placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring"
                          value={email}
                          type="email"
                          name="email"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <div className="flex">
                          <button
                            disabled={loadingEmail}
                            onClick={onClickEditEmail}
                            className="mt-2 mx-3 px-2 py-1 w-full rounded text-white text-sm shadow-sm duration-300 transition-all focus:outline-none bg-green-500 hover:bg-green-600"
                          >
                            {loadingEmail ? <div>Loading...</div> : "บันทึก"}
                          </button>
                          <button
                            onClick={() => setIsEditEmail(false)}
                            className="mt-2 mx-3 px-2 py-1 w-full rounded text-white text-sm shadow-sm duration-300 transition-all focus:outline-none bg-red-500 hover:bg-red-600"
                          >
                            ยกเลิก
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex">
                        <input
                          className="ml-2 px-2 py-1 w-full placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring"
                          value={passwordEmail}
                          type="password"
                          name="password"
                          placeholder="Password"
                          onChange={(e) => setPasswordEmail(e.target.value)}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="flex space-x-1">
                    <div>{email}</div>
                    <div
                      className=" text-blue-400 cursor-pointer"
                      onClick={() => setIsEditEmail(true)}
                    >
                      แก้ไข
                    </div>
                  </div>
                )}
              </div>
              <div className="border border-gray-200 mt-4 px-2 py-3 mx-auto flex flex-row">
                <div className="flex flex-col">
                  {oriAttachments.length > 0 &&
                    oriAttachments.map((oriAttachment, index) => {
                      return (
                        <div className="flex space-x-1 items-center">
                          <a
                            href={oriAttachment.link}
                            className="text-blue-500 mr-2"
                          >
                            {oriAttachment.name}
                          </a>
                          <div
                            className="text-sm text-red-400 cursor-pointer"
                            onClick={() => onDeleteAttachment(index)}
                          >
                            ลบ
                          </div>
                        </div>
                      );
                    })}
                </div>
                <input
                  type="file"
                  name="attachments"
                  multiple="multiple"
                  onChange={onChangeAttachment}
                  ref={fileRef}
                />
                <div>
                  {attachmentViews.length > 0 &&
                    attachmentViews.map((attachmentView) => {
                      return (
                        <div className="text-left text-blue-500">
                          {attachmentView?.name}
                        </div>
                      );
                    })}
                </div>

                <button
                  disabled={loadingSaveAttchment || !checkEdit}
                  onClick={onSaveAttachment}
                  className={classNames("px-2 ml-2 py-1  rounded ", {
                    "bg-green-500 cursor-pointer text-white":
                      !loadingSaveAttchment || checkEdit,
                    "bg-gray-400 cursor-not-allowed":
                      loadingSaveAttchment || !checkEdit,
                  })}
                >
                  {loadingSaveAttchment ? "กำลังบันทึกไฟล์" : "บันทึกไฟล์"}
                </button>
              </div>
              <div className="border border-gray-200  mt-4 px-2 py-2 mx-auto flex space-x-1">
                {data.caseNumber ? (
                  <div className="text-gray-600">เลขคดี {data.caseNumber}</div>
                ) : (
                  <div className="flex">
                    <input
                      onChange={onChangeCaseNumber}
                      value={caseNumber}
                      placeholder="หมายเลขคดี"
                      className="px-3  py-2 placeholder-blueGray-400 text-gray-700 relative bg-white rounded text-sm border border-gray-200 outline-none focus:outline-none w-full"
                    />
                    <button
                      disabled={loadingCaseNumber || !caseNumber?.length}
                      onClick={onClickUpdateCaseNumber}
                      className={classNames(
                        "px-3 py-2 ml-1  text-white  rounded",
                        {
                          "bg-gray-400 cursor-not-allowed":
                            loadingCaseNumber || !caseNumber?.length,
                          "bg-green-400 cursor-pointer ":
                            !loadingCaseNumber && caseNumber?.length > 0,
                        }
                      )}
                    >
                      {loadingCaseNumber ? "Loading..." : "ยืนยัน"}
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* QR Code */}
            {data.loan_status !== "DONE" && (
              <div className="mt-2 flex flex-col items-center justify-center">
                <div className="">QR Code Payment</div>
                <input
                  type="text"
                  placeholder="เบอร์โทร"
                  value={phone_number}
                  className="mb-1 px-3  py-2 placeholder-blueGray-400 text-gray-700 relative bg-white rounded text-sm border border-gray-200 outline-none focus:outline-none"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <div className="flex space-x-1">
                  <div>ยอดรวม</div>
                  <div>{Number(getValueAmount(data)).toFixed(0)}</div>
                </div>
                <button
                  disabled={
                    loadingQrPayment ||
                    data?.loan_status === "DONE" ||
                    !phone_number?.length
                  }
                  onClick={onClickSendQRSMS}
                  className={classNames("px-3 py-2 ml-1  text-white  rounded", {
                    "bg-gray-400 cursor-not-allowed":
                      loadingQrPayment ||
                      data?.loan_status === "DONE" ||
                      !phone_number?.length,
                    "bg-green-400 cursor-pointer ":
                      !loadingQrPayment &&
                      data.loan_status !== "DONE" &&
                      phone_number?.length > 0,
                  })}
                >
                  Send SMS
                </button>
                <div className="w-36" hidden>
                  {data && (
                    <QRCode
                      id="qr_code"
                      size={135}
                      fgColor="#003690"
                      value={getBillValue(
                        `${data.loan_kbank_id}`,
                        Number(Number(getValueAmount(data)).toFixed(0)),
                        data?.evidence?.length
                      )}
                      logoImage={`/icon.png`}
                      logoWidth={32}
                      logoHeight={32}
                    />
                  )}
                </div>
              </div>
            )}

            {
              data.loan_status !== "FAIL" &&
              !checkRole(user.groups, ["Marketing"]) && (
                <div className="flex flex-row justify-between max-w-2xl mx-auto py-4 font-bold text-base">
                  <div className="p-4 px-6 border bg-gray-100 border-gray-500  mx-auto relative">
                    {isExpand ? (
                      <div>
                        <div>คำขอชำระค่างวด</div>
                        <div
                          onClick={() => setExpand(false)}
                          className="absolute top-1 right-2 text-blue-500 text-base"
                        >
                          ซ่อน
                        </div>
                        <div className={classNames("grid mt-2 grid-cols-1")}>
                          <div className="w-full h-64 bg-gray-200">
                            <div className="bg-black h-52 flex flex-col justify-center">
                              <FullScreen
                                className="w-full h-full"
                                handle={handleApprove}
                              >
                                {billBase || dataEvidence === null ? (
                                  billBase && (
                                    <img
                                      src={billBase}
                                      onClick={handleApprove.enter}
                                      className="w-full h-full object-contain bg-black"
                                    />
                                  )
                                ) : (
                                  <S3Image
                                    onClick={() =>
                                      showEvidencePopup(dataEvidence?.bill_img)
                                    }
                                    className="w-full h-52 object-contain bg-black "
                                    imgKey={
                                      dataEvidence?.bill_img === undefined
                                        ? ""
                                        : dataEvidence.bill_img
                                    }
                                  />
                                )}
                              </FullScreen>
                            </div>
                            <div className="flex flex-col h-20 justify-between mx-2  mt-1 p-1">
                              <input
                                type="file"
                                className="tex-xs"
                                onChange={onChangeFile}
                                name="bill_img"
                                value={form?.bill_img?.file}
                              />
                              {error && !billBase && (
                                <div className="flex">
                                  <span className="text-red-400 text-sm">
                                    โปรดเลือกไฟล์
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="w-full text-left text-gray-700 text-base mx-3 mt-2">
                            ยอดเงิน
                          </div>
                          <input
                            type="text"
                            className="w-full m-3 mt-0 p-1 border border-gray-300 rounded"
                            onChange={onChangeForm}
                            name="paid_amount"
                            value={form.paid_amount}
                          />
                          {error && form.paid_amount === 0 && (
                            <div className="flex mx-3">
                              <span className="text-red-400 text-sm">
                                โปรดกรอกจำนวนเงิน
                              </span>
                            </div>
                          )}
                          <div className="w-full text-left text-gray-700 text-base mx-3">
                            วัน/เวลา ที่ชำระ
                          </div>
                          <div className="mx-3 w-full grid grid-cols-12 gap-1 ">
                            <div className=" col-span-2">
                              <div className="text-left">Date</div>
                              <Select
                                options={optionsDates}
                                value={{
                                  label: `${pad(selectDate)}`,
                                  value: `${pad(selectDate)}`,
                                }}
                                onChange={(e) => onSelectDate(e)}
                              />
                            </div>
                            <div className="col-span-3">
                              <div className="text-left">Month</div>
                              <Select
                                options={optionsMonths}
                                value={{
                                  label: `${pad(selectMonth)}`,
                                  value: `${pad(selectMonth)}`,
                                }}
                                onChange={(e) => onSelectMonth(e)}
                              />
                            </div>
                            <div className="col-span-3">
                              <div className="text-left">Year</div>
                              <Select
                                options={optionsYears}
                                value={{
                                  label: selectYear,
                                  value: selectYear,
                                }}
                                onChange={(e) => onSelectYear(e)}
                              />
                            </div>
                            <div className="col-span-2">
                              <div className="text-left">Hour</div>
                              <Select
                                options={optionsHours}
                                value={{
                                  label: `${pad(selectHour)}`,
                                  value: `${pad(selectHour)}`,
                                }}
                                onChange={(e) => onSelectHour(e)}
                              />
                            </div>
                            <div className="col-span-2">
                              <div className="text-left">Minutes</div>
                              <Select
                                options={optionsMintues}
                                value={{
                                  label: `${pad(selectMinute)}`,
                                  value: `${pad(selectMinute)}`,
                                }}
                                onChange={(e) => onSelectMintue(e)}
                              />
                            </div>
                          </div>
                          {/* <input
                            type="datetime-local"
                            className="w-full m-3 mt-0 p-1 border border-gray-300 rounded"
                            onChange={onChangeForm}
                            name="paid_date"
                            value={form.paid_date}
                            max={getCurrentLocalDateTime().dateTimeLocal}
                          /> */}
                          <React.Fragment>
                            <button
                              onClick={onSubmitEvidence("APPROVE")}
                              className="mt-2 mx-3 px-4 py-1 w-full rounded text-white text-sm shadow-sm duration-300 transition-all focus:outline-none bg-green-500 hover:bg-green-600"
                            >
                              อนุมัติ
                            </button>
                            {data.confirmPayment !== null &&
                              typeof data.confirmPayment !== "undefined" && (
                                <button
                                  onClick={onSubmitCancel()}
                                  className=" px-4 py-1 mt-2 w-full mx-3 rounded text-red-500 border border-red-500 text-sm shadow-sm duration-300 transition-all focus:outline-none hover:bg-red-600 hover:text-white"
                                >
                                  ยกเลิก
                                </button>
                              )}
                            {dataEvidence && (
                              <button
                                onClick={onSubmitEvidence("REJECT")}
                                className=" px-4 py-1 mt-2 w-full mx-3 rounded text-red-500 border border-red-500 text-sm shadow-sm duration-300 transition-all focus:outline-none hover:bg-red-600 hover:text-white"
                              >
                                ปฎิเสธ
                              </button>
                            )}
                          </React.Fragment>
                        </div>
                      </div>
                    ) : (
                      <div className=" flex space-x-6 ">
                        <button onClick={() => setExpand(true)}>
                          จัดการยอดเงิน
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            {data?.installments?.map((installment, index) => {
              const disableRemain = calculatorDisabledPeriodRemain(
                data.installments
              );

              const currentDateIndex = getCheckCurrentDate(data?.installments);
              const checkCurrentDateIndex = currentDateIndex === index;
              const total = getTotalAmount(
                checkCurrentDateIndex,
                data,
                installment,
                index
              );

              // console.log("total", total);

              // let totalRemain = 0;
              // let capInstallmentRemain = 0;
              // if (disableRemain.matchIndex === index) {
              //   totalRemain = disableRemain.disabledPeriodRemain;
              // }

              // if (installment.isNewInstallment) {
              //   capInstallmentRemain += data.capitalRemain;
              // }

              return (
                <div className="flex items-center justify-center w-full mx-auto">
                  <div
                    className={classNames(
                      "border-b border-gray-300 flex flex-row w-full justify-between items-center rounded mx-4 my-0 py-4",
                      {
                        "bg-lightBlue-50": installment.isNewInstallment,
                      }
                    )}
                  >
                    <div className="items-center px-2">
                      <div className="text-sm">งวดที่ </div>
                      <div className=" text-base font-bold mt-2">
                        {index + 1}
                      </div>
                    </div>

                    <div className=" items-center px-2">
                      <div className="text-sm">เงินต้นคงเหลือ</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planCapitalRemain).format("0,0")}
                      </div>
                    </div>

                    <div className=" items-center px-2">
                      <div className="text-sm">เงินค่างวด</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planPrinciple).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm">ดอกเบี้ย</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.planInterest).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm  text-blue-500 ">
                        เงินค่างวดคงเหลือ
                      </div>
                      <div className=" text-base text-blue-500 font-bold mt-2">
                        {numeral(installment.actualPrinciple).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm text-blue-500">
                        ดอกเบี้ยคงเหลือ
                      </div>
                      <div className=" text-base text-blue-500  font-bold mt-2">
                        {numeral(installment.actualInterest).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm text-blue-500 ">ดอกเบี้ยสะสม</div>
                      <div className=" text-base text-blue-500  font-bold mt-2">
                        {numeral(installment.interestMore).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm text-red-500 ">วันที่หัก</div>
                      <div className=" text-base text-red-500 font-bold mt-2">
                        {format(new Date(installment.date), "dd-MM-yyyy")}
                      </div>
                    </div>
                    <div className=" items-center px-2 w-32">
                      <div className="text-sm text-red-500">วันที่จ่าย</div>
                      <div className=" text-base text-red-500 font-bold mt-2">
                        {installment.paid_date !== "-"
                          ? format(
                              new Date(installment.paid_date),
                              "dd-MM-yyyy"
                            )
                          : "-"}
                      </div>
                    </div>

                    <div className="items-center px-2">
                      <div className="text-sm">จ่ายแล้ว</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(installment.paid_amount).format("0,0")}
                      </div>
                    </div>

                    <div className=" items-center px-2">
                      <div className="text-sm">คงเหลือประจำงวด</div>
                      <div className=" text-base font-bold mt-2">
                        {numeral(
                          total
                          // installment.actualInterest +
                          //   installment.actualPrinciple
                          // totalRemain +
                          // capInstallmentRemain
                        ).format("0,0")}
                      </div>
                    </div>
                    <div className=" items-center px-2">
                      <div className="text-sm">สถานะ</div>
                      {statusVerison(installment)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="w-1/5 bg-gray-200 h-screen  overflow-y-scroll">
          <div className="text-black text-lg text-center mt-4">
            หลักฐานการชำระเงิน
          </div>
          <div className="m-4">
            {data.interestMoreList?.length > 0 &&
              data.interestMoreList.map((interestMore) => (
                <div className="bg-gray-100 rounded border-b gray-300 p-2">
                  <div className="flex flex-row justify-between">
                    <div className="text-sm"> ลดดอกเบี้ยสะสมจำนวน</div>
                    <div className="text-purple-500 text-sm">
                      {numeral(interestMore.paid_amount).format("0,0.00")}
                    </div>
                  </div>
                  <div className="text-xs font-medium text-gray-500">
                    {" "}
                    เหตุผล: {interestMore.reason}
                  </div>
                  <div className="text-xs text-blue-500">
                    {format(
                      new Date(interestMore.paid_date),
                      "dd/MM/yyyy HH:mm"
                    )}
                  </div>
                  <div className="text-xs">โดย {interestMore.adminName}</div>
                </div>
              ))}
          </div>

          {evidence.map((ev, index) => {
            return (
              <div
                className={
                  "m-3 py-0 flex flex-row " +
                  (index > 0 && ev.period != evidence[index - 1].period
                    ? "border-t border-gray-400 pt-3 "
                    : "py-0 m-3")
                }
              >
                {ev?.transactionId ? (
                  <img src="/kbank.jpg" className="w-20  h-24 object-cover" />
                ) : (
                  <S3Image
                    className="w-20 bg-black h-24 object-cover"
                    imgKey={ev.bill_img}
                    onClick={() => showEvidencePopup(ev.bill_img)}
                  />
                )}
                <div className="ml-4">
                  <div className={classNames("text-base")}>
                    {" "}
                    {ev.evidence_status === "APPROVE"
                      ? `งวดที่ ${ev.period}`
                      : `งวดที่ -`}
                  </div>
                  <div className="text-sm text-gray-700">
                    {numeral(ev.paid_amount).format("0,0.00")}
                  </div>
                  <div className="text-xs flex flex-row w-full space-x-1">
                    (
                    <div className="text-blue-500 flex space-x-1">
                      <div>เงินต้น</div>
                      <div>{numeral(ev.paid_principle).format("0,0")},</div>
                    </div>
                    <div className="text-green-500 flex space-x-1">
                      <div>โปะ</div>
                      <div>{numeral(ev.paid_overflow).format("0,0")},</div>
                    </div>
                    )
                  </div>
                  <div className="text-xs flex flex-row w-full space-x-1">
                    (
                    <div className="text-orange-500 flex space-x-1">
                      <div>ดอกเบี้ย</div>
                      <div>{numeral(ev.paid_interest).format("0,0")},</div>
                    </div>
                    <div className="text-red-500 flex space-x-1">
                      <div>ดอกเบี้ยสะสม</div>
                      <div>{numeral(ev.paid_interestMore).format("0,0")}</div>
                    </div>
                    )
                  </div>
                  <div className="text-xs text-blue-500">
                    {format(new Date(ev.paid_date), "dd/MM/yyyy HH:mm")}
                  </div>
                  <div
                    className={
                      ev.evidence_status == "APPROVE"
                        ? "text-green-500 text-xs"
                        : "text-red-500 text-xs"
                    }
                  >
                    {ev.evidence_status}
                  </div>
                  {ev?.transactionId ? (
                    <div className="text-xs text-gray-600">
                      {ev.transactionId}
                    </div>
                  ) : (
                    <div className="text-xs">โดย {ev.adminName}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default LoanId;
